import { styled, Typography } from '@mui/material';

export const Card = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '456px',
  borderRadius: '24px',
  padding: '28px',
  backgroundColor: theme.palette.color.global.card,

  '&:first-of-type': {
    top: '50px',
    left: 0,

    [theme.breakpoints.down('2xl')]: {
      top: '24px',
    },
    [theme.breakpoints.down('md')]: {
      top: 'auto',
      left: 'auto',
    },
  },
  '&:last-of-type': {
    top: '160px',
    right: 0,

    [theme.breakpoints.down('2xl')]: {
      top: '140px',
    },
    [theme.breakpoints.down('lg')]: {
      top: '116px',
    },
    [theme.breakpoints.down('md')]: {
      top: 'auto',
      right: 'auto',
    },
  },

  [theme.breakpoints.down('2xl')]: {
    width: '320px',
    padding: '24px',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '20px',
  },
  [theme.breakpoints.down('md')]: {
    position: 'relative',
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
  },
}));

export const User = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  paddingBottom: '8px',
  borderBottom: `1px solid ${theme.palette.color.divider}`,
}));

export const Name = styled(Typography)(({ theme }) => ({
  flex: '1 1 auto',
  fontWeight: 600,
  color: theme.palette.color.fg.primary,
}));

export const PostedIn = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 0',
  borderBottom: `1px solid ${theme.palette.color.divider}`,
}));

export const PostedInLabel = styled(Typography)(() => ({
  fontWeight: 500,
}));

export const PostedInText = styled(Typography)(({ theme }) => ({
  color: theme.palette.color.fg.primary,
}));

export const Title = styled(Typography)(({ theme }) => ({
  margin: '20px 0',

  [theme.breakpoints.down('md')]: {
    margin: '16px 0',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '12px 0',
  },
}));

export const Text = styled(Typography)({});
